// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dvHo0YSrzUcJJqCuPxvUk","content-wrapper":"_2cDOhvfZjKzc9S8djg0RbY"};